import { FC } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { Separator } from "@/components/ui/separator";

const OrderSummarySkeleton: FC = () => {
  return (
    <div className="rounded-xl border bg-white p-6 shadow-sm">
      {/* Title */}
      <Skeleton className="h-6 w-36 mb-5" />

      {/* Service title */}
      <Skeleton className="h-4 w-3/4 mb-2" />
      {/* Service subtitle */}
      <Skeleton className="h-3 w-1/2" />

      <Separator className="my-4" />

      {/* Total row */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-5 w-10" />
        <Skeleton className="h-5 w-20" />
      </div>

      {/* Badges */}
      <div className="mt-6 space-y-2">
        <div className="flex items-center gap-2">
          <Skeleton className="size-4 rounded-full shrink-0" />
          <Skeleton className="h-3 w-36" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="size-4 rounded-full shrink-0" />
          <Skeleton className="h-3 w-32" />
        </div>
      </div>
    </div>
  );
};

const PaymentPanelSkeleton: FC = () => {
  return (
    <div className="rounded-xl border bg-white p-6 shadow-sm">
      {/* Title */}
      <Skeleton className="h-6 w-48 mb-6" />

      {/* Select method label */}
      <Skeleton className="h-3 w-40 mb-3" />

      {/* Payment method card 1 */}
      <div className="rounded-lg border p-4 flex items-center gap-4 mb-3">
        <Skeleton className="size-4 rounded-full shrink-0" />
        <Skeleton className="size-5 rounded shrink-0" />
        <div className="flex-1 space-y-1.5">
          <Skeleton className="h-3.5 w-36" />
          <Skeleton className="h-3 w-24" />
        </div>
      </div>

      {/* Payment method card 2 */}
      <div className="rounded-lg border p-4 flex items-center gap-4 mb-3">
        <Skeleton className="size-4 rounded-full shrink-0" />
        <Skeleton className="size-5 rounded shrink-0" />
        <div className="flex-1 space-y-1.5">
          <Skeleton className="h-3.5 w-40" />
          <Skeleton className="h-3 w-20" />
        </div>
      </div>

      {/* Add new card row */}
      <div className="rounded-lg border p-4 flex items-center gap-4 mb-6">
        <Skeleton className="size-4 rounded-full shrink-0" />
        <Skeleton className="size-5 rounded shrink-0" />
        <Skeleton className="h-3.5 w-28" />
      </div>

      {/* Pay button */}
      <Skeleton className="h-11 w-full rounded-lg" />
    </div>
  );
};

const CheckoutSkeleton: FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-5xl px-4 py-8">
        <div className="grid md:grid-cols-[1fr_2fr] gap-6 items-start">
          <OrderSummarySkeleton />
          <PaymentPanelSkeleton />
        </div>
      </div>
    </div>
  );
};

export default CheckoutSkeleton;
